import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, switchMap} from 'rxjs/operators';
import {getConversations, loadConversationsSuccess} from './conversation.actions';
import {SingleOrderService} from '../../dashboard/account-orders/single-order/single-order.service';


@Injectable()
export class ConversationEffects {

  constructor(private actions$: Actions, private singleOrderService: SingleOrderService) {
  }

  getConversations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getConversations),
      switchMap((action) => {
        const orderId = action.orderId; // Extract orderId from the action payload
        return this.singleOrderService
          .getOrderMessages(orderId)
          .pipe(
            map((res: any) => {
              if (res.code === 200) {
                return loadConversationsSuccess({conversation: res?.data});
              }
            }),
          );
      }),
    ),
  );


}
